import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';
import { AlertService } from '@main/alert.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [ReactiveFormsModule, RouterLink]
})
export class LoginComponent implements OnInit {

  // Properties
    version: string = environment.version;

  employeePortalUrl!: string;
  loginForm: UntypedFormGroup;
  mobileUser: any = {
    user: '',
    pw: ''
  }

  constructor(private authService: AuthService,
    private router: Router,
  private alertService: AlertService) { }

  ngOnInit(): void {
    this.employeePortalUrl = 'https://employee.' + document.location.host;

    if (localStorage.getItem('mobileUser')) {
      let creds = JSON.parse(localStorage.getItem('mobileUser'));

      this.mobileUser.user = creds.user;
      this.mobileUser.pw = creds.pw;
    }
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(this.mobileUser.user ? this.mobileUser.user : ''),
      password: new UntypedFormControl(this.mobileUser.pw ? this.mobileUser.pw : '')
    });
  }

  // Login
  async login(): Promise<void> {
    let login = await lastValueFrom(this.authService.login(this.loginForm.value.email, this.loginForm.value.password));
    localStorage.setItem('login', JSON.stringify(login));
    if (login.isMobile) {
      let credentials = {
        user: this.loginForm.value.email,
        pw: this.loginForm.value.password
      }
      localStorage.setItem('mobileUser', JSON.stringify(credentials));
    }
    if ((login.role == 'SUPER' || login.role == 'FRANCHISE_OWNER') && (!login.providesAccess || login.subscription.organizationStatus == "DELINQUENT" || login.subscription.organizationStatus == "INACTIVE" || !login.isWithCardOnFile)) {
      this.alertService.showErrorAlert('No card on file. Please add a card to continue using Tinsel.');
      this.router.navigateByUrl('/change-subscription', { replaceUrl: true });
      return;
    }

    const lastRoute = sessionStorage.getItem('LastRoute');
    if (lastRoute !== null) {
      this.router.navigateByUrl(lastRoute, { replaceUrl: true });
      sessionStorage.removeItem('LastRoute');
    } else {
      this.router.navigateByUrl('/dashboard', { replaceUrl: true });
    }
  }

  // Login Form Accessors
  get email() { return this.loginForm.controls.email; }
  get password() { return this.loginForm.controls.password; }
}
